@use '../../../styles/Constants.scss' as Constants;
@use '../../../styles/Colors.scss' as Colors;

.textarea {
	padding: Constants.$val-spacing-s;
	outline: none;
	box-shadow: none !important;
	-webkit-box-shadow: none !important;
	height: 100% !important;
	font-size: Constants.$val-fontSizeSmall !important;
	border: 0 !important;
	color: Colors.$col-blackDark;

	&.with-error {
		background-color: Colors.$col-redBackground !important;
	}
	
}

.error-placeholder::placeholder {
	color: Colors.$col-red !important; 
	opacity: 1; 
}

.textarea-wrapper {
	position: relative;
	display: inline-block;
	
	[class^="icon-notification_status"] {
		position: absolute;
		top: 1px;
		left: 0;
		z-index: 3;
		color: Colors.$col-red;
		pointer-events: auto; 
	}
	
	:global(.form-control) {
		height: 100% !important;
	}
}



